export const CHANGE_CHAT = 'CHANGE_CHAT'